// extracted by mini-css-extract-plugin
export default {"page":"Document_page__ZdTn6"};